/**
 * AfA-Konto passend zum Anlagekonto (SKR04, wie im Kontenrahmen hinterlegt):
 * Fahrzeuge 05xx → 6222, immaterielle VG 01xx → 6200, sonst 6220.
 */
export function depreciationAccountFor(assetAccountNo) {
  if (/^05[2-6]/.test(assetAccountNo || '')) return '6222';
  if (/^01/.test(assetAccountNo || '')) return '6200';
  return '6220';
}
